import { SystemContext } from "./SystemContext";
import * as React from "react";
import { withRouter } from 'react-router-dom';
 class SystemProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      queryFilter: window.queryFilter, setGlobalState: this.setGlobalState, filterToggle: this.filterToggle(), handleActiveClassClick: this.handleActiveClassClick
    };
  }
   handleActiveClassClick = (param,event=false) => {
      var filterActive = (this.state.queryFilter.filterActive != param) ? param : false;
     this.setGlobalState({ filterActive }, false);
   }
   setGlobalState = (param = false,bookmarkparam = true)=>{
    let queryFilter = this.state.queryFilter;
    for (const [key, value] of Object.entries(param)) {
      queryFilter[key] = value;
    }
    if(param ){
      this.setState({queryFilter});
      if (bookmarkparam) {
      this.setBookMarking();
      }
    }
   }
   setBookMarking = () => {
    if (history.pushState) {
      var link = '';
      link += `?`;
      if (this.state.queryFilter["searchkey"]){
        link += `&searchkey=${btoa(this.state.queryFilter["searchkey"])}`;
      }
      if (this.state.queryFilter["startdate"]) {
        link += `&startdate=${btoa(this.state.queryFilter["startdate"])}`;
      }
      if (queryFilter["enddate"]) {
        link += `&enddate=${btoa(this.state.queryFilter["enddate"])}`;
      }
      if (this.state.queryFilter["comstartdate"]) {
        link += `&comstartdate=${btoa(this.state.queryFilter["comstartdate"])}`;
      }
      if (queryFilter["comenddate"]) {
        link += `&comenddate=${btoa(this.state.queryFilter["comenddate"])}`;
      }
      if (queryFilter["selectedCourse"] && queryFilter["selectedCourse"] != '') {
        link += `&selectedCourse=${btoa(this.state.queryFilter["selectedCourse"])}`;
      }
      if (queryFilter["branches"] && queryFilter["branches"] != '') {
        link += `&branches=${btoa(this.state.queryFilter["branches"])}`;
      }
      if (queryFilter["batches"] && queryFilter["batches"] != '') {
        link += `&batches=${btoa(this.state.queryFilter["batches"])}`;
      }
      if (queryFilter["grades"] && queryFilter["grades"] != '') {
        link += `&grades=${btoa(this.state.queryFilter["grades"])}`;
      }
      if (queryFilter["certificate"] && queryFilter["certificate"] != '') {
        link += `&certificate=${btoa(this.state.queryFilter["certificate"])}`;
      }
      if (queryFilter["minProgressRange"] && queryFilter["minProgressRange"] != '') {
        link += `&minProgressRange=${btoa(this.state.queryFilter["minProgressRange"])}`;
      }
      if (queryFilter["maxProgressRange"] && queryFilter["maxProgressRange"] != '') {
        link += `&maxProgressRange=${btoa(this.state.queryFilter["maxProgressRange"])}`;
      }
      if (queryFilter["progressstatus"] && queryFilter["progressstatus"] != '') {
        link += `&progressstatus=${btoa(this.state.queryFilter["progressstatus"])}`;
      }
      if (queryFilter["faculties"] && queryFilter["faculties"] != '') {
        link += `&faculties=${btoa(this.state.queryFilter["faculties"])}`;
      }
      if (queryFilter["certificateStatus"] && queryFilter["certificateStatus"] != '') {
        link += `&certificateStatus=${btoa(this.state.queryFilter["certificateStatus"])}`;
      }
      if (this.state.queryFilter["certexpirystartdate"]) {
        link += `&certexpirystartdate=${btoa(this.state.queryFilter["certexpirystartdate"])}`;
      }
      if (queryFilter["certexpiryenddate"]) {
        link += `&certexpiryenddate=${btoa(this.state.queryFilter["certexpiryenddate"])}`;
      }
    this.props.history.push(link);
    }
  }
  filterToggle = ()=>{
   let toggleValue = false;
    for (const [key, value] of Object.entries( window.queryFilter)) {
      if( value ){
        toggleValue = true;
      }
    }
    return toggleValue
  }
  render() {
    return (
      <SystemContext.Provider
        value={{
            ...this.state
        }}
      >
        {this.props.children}
      </SystemContext.Provider>
    );
  }
}
export default withRouter(SystemProvider);